import { PRODUCT_DETAILS } from "../constants";

// given the availabile product packages, return the selected product
// defaults to the first product otherwise

function _getQualifyingCondition(product, productDetail) {
	switch (productDetail.name) {
		case PRODUCT_DETAILS.ID: {
			return product[PRODUCT_DETAILS.ID] === productDetail.value;
		}

		case PRODUCT_DETAILS.TOKENS_NUM: {
			return parseInt(product[PRODUCT_DETAILS.TOKENS_NUM], 10) ===
				parseInt(productDetail.value, 10);
		}

		case PRODUCT_DETAILS.SUB_PERIOD: {
			return parseInt(product[PRODUCT_DETAILS.SUB_PERIOD], 10) ===
				parseInt(productDetail.value, 10);
		}

		default: {
			return false;
		}
	}
}

export default function getSelectedProduct(productPackages, productDetail) {
	return (
		productPackages
			.filter((p) => _getQualifyingCondition(p, productDetail))
			.reduce((memo, p) => p, null)
	) || productPackages[0];
}



// WEBPACK FOOTER //
// ./src/shared/payment/helpers/getSelectedProduct.js